import RemoLogo from "./RemoLogo";

export type { IRemoLogoProps } from "./RemoLogo";

export default RemoLogo;
